module.exports = __webpack_public_path__ + "media/images/products/template/01/01-44331dd3e4a5c219225d47b9604af1ec.jpg";